import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PayrollService } from 'src/app/services/payroll.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-history-rrhh',
  templateUrl: './history-rrhh.component.html',
  styleUrls: ['./history-rrhh.component.scss']
})
export class HistoryRrhhComponent {

  generatedPayrolls = [];
  searchText: string = '';
  startDate: string = '';
  endDate: string = '';
  filteredPayrolls: any[] = [];
  expanded: { [id: number]: boolean } = {};
  numberOfEmployees = 0;
  year = "";
  paymentPeriod: number;
  paginationPayrolls = {
    total: [],
    filter: [],
    pageSize: 5,
    pageIndex: 0,
    startElement: 0,
    lastElement: 0
  };
  payrollSelected: any = null;
  payrollSelectedMonth: number = null;

  PAYROLL_TYPE_MAP: { [key: number]: string } = {
    // TIPOS DE PAGOS
    200: 'SALARIO',
    201: 'AGUINALDO',
    202: 'BONO14',
    203: 'VACACIONES',
    204: 'LIQUIDACION',
  
    // TIPOS DE DESCUENTOS
    300: 'AUSENCIAS',
    301: 'ISR',
    302: 'IGSS',
    303: 'DESCUENTOS ANTICIPO',
    304: 'PRESTAMOS BANCARIOS',
    305: 'DEMANDA JUDICIAL',
    306: 'OTROS DESCUENTOS',
  
    // INGRESOS
    400: 'BONIFICACIÓN INCENTIVO',
    401: 'HORAS EXTRA',
    402: 'COMISIONES',
    403: 'OTRAS BONIFICACIONES',
    404: 'OTROS INGRESOS'
  };
  
  

  constructor(
    private payrollService: PayrollService,
    private toastService: ToastrService,
    private rrhh: HumanResourcesService,
  ) {
    
  }
  
  ngOnInit(): void {
    
  }

  searchGeneratedPayrolls(){
    this.getHistoryGenerateds();
  }

  getPayrollTypeText(id: number): string {
    return this.PAYROLL_TYPE_MAP[id] ?? 'DESCONOCIDO';
  }

  showPayrollDetail(payroll: any) {
    this.payrollSelected = payroll;

    // Extraer el número de mes del encabezado
    const match = payroll.header?.match(/Pago Mensual numero (\d+)/i);
    if (match && match[1]) {
      this.payrollSelectedMonth = parseInt(match[1], 10) + 1;
    } else {
      this.payrollSelectedMonth = null;
    }
  }


  resetPaginationPayrolls() {
    this.paginationPayrolls.pageIndex = 0;
    this.paginationPayrolls.startElement = 0;
    this.paginationPayrolls.filter = this.paginationPayrolls.total.slice(0, this.paginationPayrolls.pageSize);
    this.paginationPayrolls.lastElement = this.paginationPayrolls.filter.length;
  }
  
  filterPayrolls() {
    let result = this.generatedPayrolls.filter(payroll => {
      const matchesSearch = this.searchText ? payroll.header.toLowerCase().includes(this.searchText.toLowerCase()) : true;
      const payrollDate = new Date(payroll.date);
      const afterStart = this.startDate ? payrollDate >= new Date(this.startDate) : true;
      const beforeEnd = this.endDate ? payrollDate <= new Date(this.endDate) : true;
      return matchesSearch && afterStart && beforeEnd;
    });
  
    this.paginationPayrolls.total = result;
    this.paginationPayrolls.pageIndex = 0;
    this.paginationPayrolls.startElement = 0;
    this.paginationPayrolls.filter = result.slice(0, this.paginationPayrolls.pageSize);
    this.paginationPayrolls.lastElement = this.paginationPayrolls.filter.length;
  }
  
  

  getHistoryGenerateds() {
    this.payrollService.getGeneratedPayroll(this.year, this.paymentPeriod).subscribe({
      next: (response: ResponseObject) => {
        this.generatedPayrolls = response.data;
        this.paginationPayrolls.total = this.generatedPayrolls;
        this.resetPaginationPayrolls();
        this.filterPayrolls();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getNumberEmployees(){
    this.rrhh.getPaymentContractCompany(this.paymentPeriod).subscribe({
      next: (response: ResponseObject) => {
        this.numberOfEmployees = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }
  
  getLastDayOfSelectedPayroll(): Date | null {
    if (!this.payrollSelectedMonth || !this.year) return null;
    return new Date(+this.year, this.payrollSelectedMonth, 0); // Día 0 del siguiente mes = último día del mes actual
  }  
  

}
